import React from 'react';
import { EffectivePermissions } from '@src/services/users/myPermissions/myPermissionsApiSliceTypes';
import { PermissionGuard } from './PermissionGuard';

type ActionGuardProps = {
    module: keyof EffectivePermissions;
    children: React.ReactNode;
};

export const ActionGuard = ({ module, children }: ActionGuardProps) => (
    <PermissionGuard module={module} allowedRoles={['admin']}>
        {children}
    </PermissionGuard>
);
